import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CommonService } from '@frontend/promo-homewidget';
import { CommonConstants, DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsButton } from '@frontend/ui/button';
import { DsCard } from '@frontend/ui/card';
import { ContentLink, NavigationService, PlainLinkComponent } from '@frontend/vanilla/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { OnClickWTDirective } from '../../../../../common/web-tracking/onclick-web-tracking.directive';
import { WebAnalyticModel } from '../../../../../common/web-tracking/web-analytic.model';
import { CommonEventService } from '../../events/common-event.service';
import { CrossSellingInfo } from '../../models/results/cross-selling-info';
import { TargetPromoState, commonContentMessages, resultsContent } from '../../store/target-promotion.selectors';

interface CrossSellingInfoViewModel extends CrossSellingInfo {
    checkOtherPromotionsText: string;
    webAnalytic: WebAnalyticModel;
}

@Component({
    selector: 'tp-cross-selling',
    templateUrl: './cross-selling.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, PlainLinkComponent, OnClickWTDirective, DsCard, DsButton],
})
export class CrossSellingComponent {
    dsComponents: DSComponents;
    vm$: Observable<CrossSellingInfoViewModel> = combineLatest([
        this.store?.select(resultsContent),
        this.store?.select(commonContentMessages),
        this.commonEventService.getWAModel(),
    ]).pipe(
        map(([resultsContent, commonContentMessages, webAnalytic]) => {
            const crossSellingInfo = resultsContent?.crossSellingInfos;
            if (crossSellingInfo !== undefined && commonContentMessages) {
                return {
                    title: crossSellingInfo?.title,
                    description: crossSellingInfo?.description,
                    content: crossSellingInfo?.content,
                    headerImage: crossSellingInfo?.headerImage,
                    checkOtherPromotions: this.mapDsButtonConfig(crossSellingInfo?.checkOtherPromotions),
                    checkOtherPromotionsText: crossSellingInfo?.checkOtherPromotions?.text
                        ? crossSellingInfo?.checkOtherPromotions?.text
                        : commonContentMessages?.checkotherpromotions,
                    webAnalytic,
                };
            }
            return {} as CrossSellingInfoViewModel;
        }),
    );
    dsButtonConfig: { [key: string]: any };

    constructor(
        private store: Store<{ targetPromotionModuleData: TargetPromoState }>,
        private commonService: CommonService,
        private commonEventService: CommonEventService,
        private navigationService: NavigationService,
        private designSystemHelperService: DesignSystemHelperService,
    ) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
        this.dsButtonConfig = this.designSystemHelperService.getDsComponentsList(CommonConstants.checkOtherPromotions)?.dsButton;
    }

    checkOtherPromotions(checkOtherPromotions: ContentLink) {
        if (checkOtherPromotions?.url) {
            this.navigationService.goTo(checkOtherPromotions?.url);
        } else {
            this.commonService.goToOverviewPage();
        }
    }

    mapDsButtonConfig(checkOtherPromotions: ContentLink) {
        if (checkOtherPromotions?.attributes && Object.keys(checkOtherPromotions.attributes)?.length == 0) {
            let attributes: { [key: string]: any } = {};
            attributes['data-btn-size'] = this.dsButtonConfig?.size;
            attributes['data-btn-variant'] = this.dsButtonConfig?.variant;
            attributes['data-btn-kind'] = this.dsButtonConfig?.kind;
            checkOtherPromotions.attributes = attributes;
        }
        return checkOtherPromotions;
    }
}
